import React, { ComponentProps, useCallback, useEffect, useState } from 'react'

import { styled } from 'nativewind'

import { XStack } from '../layout'
import { stringToHslColor } from '../utils'
import Avatar from './Avatar'

export type AvatarArray = { image?: string | null | undefined; name: string }

const AvatarGroupWrapper = styled(XStack, 'pl-3 ', {
  variants: {
    size: {
      small: 'w-24',
      medium: 'w-32',
      large: 'w-40',
    },
  },
  defaultProps: {
    size: 'medium',
  },
})

type AvatarGroupProps = ComponentProps<typeof AvatarGroupWrapper> & {
  data: AvatarArray[]
}

export default function AvatarGroup({
  size,
  data,
  ...props
}: AvatarGroupProps) {
  const [shortenedArray, setShortenedArray] = useState<AvatarArray[]>([])
  const [remainingCount, setRemainingCount] = useState<number>(0)

  const computeData = () => {
    const extras = data?.length - 3
    setRemainingCount(extras)
    const newArray = data?.slice(0, 4)
    setShortenedArray(newArray)
  }

  const getCouputeData = useCallback(computeData, [data])

  useEffect(() => {
    getCouputeData()
  }, [getCouputeData])

  return (
    <AvatarGroupWrapper size={size} {...props}>
      {shortenedArray?.map(({ name, image }, index) => (
        <Avatar
          name={name}
          image={image}
          key={`${name + index.toString()}`}
          index={index}
          remainingCount={remainingCount}
          size={size}
          group
          avatarBackground={stringToHslColor(name ?? '')}
        />
      ))}
    </AvatarGroupWrapper>
  )
}
